var LanguageSwitcher = /** @class */ (function () {
    function LanguageSwitcher() {
        this.languageMenuContainer = document.querySelectorAll('[data-language-menu]');
        this.addEventListeners();
    }
    LanguageSwitcher.prototype.addEventListeners = function () {
        var _this = this;
        this.languageMenuContainer.forEach(function (toggle) {
            toggle.querySelector('.item-title').addEventListener('click', function (event) { return _this.toggleLanguageMenu(event); });
        });
    };
    LanguageSwitcher.prototype.toggleLanguageMenu = function (event) {
        var toggle = event.currentTarget;
        var toggleParent = toggle.parentElement;
        if (toggleParent.classList.contains('active')) {
            toggleParent.classList.remove('active');
        }
        else {
            toggleParent.classList.add('active');
        }
    };
    return LanguageSwitcher;
}());
export default LanguageSwitcher;
